import http from '../../../Utils/http';

const TriggerSync = {
  name: 'signJetSyncTrigger',
  state: {
    loading: false,
    error: '',
    result: null,
  },
  reducers: {
    TriggerRequested(state) {
      return { ...state, loading: true, error: '', result: null };
    },
    TriggerSucceeded(state, payload) {
      return { ...state, loading: false, error: '', result: payload?.data || payload || null };
    },
    TriggerFailed(state, payload) {
      return { ...state, loading: false, error: payload, result: null };
    },
    TriggerReset(state) {
      return { ...state, loading: false, error: '', result: null };
    },
  },
  effects: () => ({
    async triggerSync() {
      try {
        this.TriggerRequested();
        const response = await http.post('savvy/signjet-sync/trigger');
        this.TriggerSucceeded(response.data);
      } catch (err) {
        const message = err?.response?.data?.error || err?.message || 'Unknown error';
        this.TriggerFailed(message);
      }
    },
  }),
};

export default TriggerSync;
